var is_online = process.argv.length >= 3 && (process.argv[2] === 'online')

export function isOnline() {
  let host = location.hostname||location.host;
  return (host=='h.oasisapp.cn')
}

export function isOnlineHost() {//mtest location判断
  let host = location.hostname||location.host;
  let rusult = host == 'h.oasisapp.cn' ? 'm.oasisapp.cn' : 'mtest.oasisapp.cn'
  return rusult;
}

export function isYjbUrl() {//mtest location判断
  let host = location.hostname||location.host;
  let rusult = host == 'h.oasisapp.cn' ? 'https://e.oasisapp.cn' : 'https://etest.oasisapp.cn'
  return rusult;
}

export function idcardinfo(idcard) {
  var result = {}
  if (idcard.length == 15) idcard = idcard.substring(9) + '19' + idcard.slice(6) + '0'
  result.birthday = idcard.substr(6, 4) + "-" + idcard.substr(10, 2) + "-" + idcard.substr(12, 2);
  var y = new Date().getFullYear();
  result.age = Number(y) - Number(idcard.substr(6, 4))
  result.sexcode = (idcard.substr(16, 1) % 2 ? "1001" : "1002")
  return result
}

export function ismobile(m) {
  return (/^1\d{10}$/.test(m));
}

export function getauth() {
  if(getBrowser().isapp){
    var auth = {
      appversion:getBrowser().version,
      os:getBrowser().isios ? getBrowser().model : getBrowser().device,
    }
  }else{
    var auth = {
      crcstring: Date.now(),
      channel: document.location.host
    }
  }
  return auth;
}

export function IdCardValidate(idCard) {
  // idCard = trim(idCard.replace(/ /g, "")); //去掉字符串头尾空格
  if (idCard.length == 15) {
    return isValidityBrithBy15IdCard(idCard); //进行15位身份证的验证
  } else if (idCard.length == 18) {
    var a_idCard = idCard.split(""); // 得到身份证数组
    if (isValidityBrithBy18IdCard(idCard) && isTrueValidateCodeBy18IdCard(a_idCard)) { //进行18位身份证的基本验证和第18位的验证
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function isTrueValidateCodeBy18IdCard(a_idCard) {
  var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
  var ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X
  var sum = 0; // 声明加权求和变量
  if (a_idCard[17].toLowerCase() == 'x') {
    a_idCard[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
  }
  for (var i = 0; i < 17; i++) {
    sum += Wi[i] * a_idCard[i]; // 加权求和
  }
  var valCodePosition = sum % 11; // 得到验证码所位置
  if (a_idCard[17] == ValideCode[valCodePosition]) {
    return true;
  } else {
    return false;
  }
}
export function isValidityBrithBy15IdCard(idCard15) {
    var year = idCard15.substring(6, 8);
    var month = idCard15.substring(8, 10);
    var day = idCard15.substring(10, 12);
    var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
    // 对于老身份证中的你年龄则不需考虑千年虫问题而使用getYear()方法
    if (temp_date.getYear() != parseFloat(year) ||
        temp_date.getMonth() != parseFloat(month) - 1 ||
        temp_date.getDate() != parseFloat(day)) {
        return false;
    } else {
        return true;
    }
}
export function isValidityBrithBy18IdCard(idCard18) {
  var year = idCard18.substring(6, 10);
  var month = idCard18.substring(10, 12);
  var day = idCard18.substring(12, 14);
  var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
  // 这里用getFullYear()获取年份，避免千年虫问题
  if (temp_date.getFullYear() != parseFloat(year) ||
    temp_date.getMonth() != parseFloat(month) - 1 ||
    temp_date.getDate() != parseFloat(day)) {
    return false;
  } else {
    return true;
  }
}

export function getBrowser() {
  //ios|android-oasisapp-client|doctor|nurse-channel/2.5.4
  var browser = {};

  var ua = navigator.userAgent.toLowerCase();
  //是否微信
  browser.isweixin = (ua.match(/MicroMessenger/i) == "micromessenger")
  //完整ua
  browser.ua = ua;
  //是否泓华app
  browser.isapp = ua.indexOf('oasisapp') > 0;
  //是否安卓设备
  browser.isandroid = ua.indexOf('android-oasisapp') > 0;
  //是否ios设备
  browser.isios = ua.indexOf('ios-oasisapp') > 0;
  //是否客户端
  browser.isclient = ua.indexOf('oasisapp-client') > 0;
  //是否医生端
  browser.isdoctor = ua.indexOf('oasisapp-doctor') > 0;
  //是否护士端
  browser.isnurse = ua.indexOf('oasisapp-nurse') > 0;
  //是否医企乐
  browser.isyiqile = ua.indexOf('oasisapp-client-yiqile') > 0;
  //如果是app
  if (browser.isapp) {
    //泓华完整标识
    browser.oasis = ua.split('&&&')[1] || ua.split('oasisapp-')[1];
    //设备 iso|android
    browser.device = browser.oasis.split('-')[0];
    //客户端类型 client|doctor|nurse
    browser.client = ua.split('-oasisapp-')[1].split('/')[0];
    //客户端版本号
    browser.version = ua.split('-oasisapp-')[1].split('/')[1];
    //手机型号
    browser.model = ua.split('-oasisapp-')[1].split('/')[2];
		//app来源
		browser.channel = ua.split('-oasisapp-')[1].split('/')[0].split('-').length == 2 ? ua.split('-oasisapp-')[1].split('/')[0].split('-')[1] : ''
  }
  return browser;
}

export function domain() {
  return document.location.origin;
}

export function downloadDaren() {
  window.location.href = "https://daren.oasisapp.cn/homePage/index?login=false";
}
export function downloadUser() {
  window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.lcworld.oasismedical";
}
export function downloadWeixin() {
  window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwMjM3NDU2Mg==&scene=124#wechat_redirect";
}
export function wxLogin() {
  location.href = domain() + '/wxofficial/login.html?url=' + encodeURIComponent(location.href)
}

//替换模版
export function moban(obj, str) {
  if (typeof(obj) == 'object') {
    for (var name in obj) {
      var reg = new RegExp('\\{' + name + '\\}', 'g');
      var value = obj[name];
      //var reg=new RegExp('/title/g');
      if (value == null) {
        value = ''
      }
      str = str.replace(reg, value)
    }
  }

  return str;
}

export function getaccountid() {
  let accountid = getCookie("accountid") || '';
  return accountid;
}

export function getACCESS_TOKEN() {
  let ACCESS_TOKEN = getCookie('ACCESS_TOKEN') || '';
  return ACCESS_TOKEN;
}

export function checkLogin() {
  let ACCESS_TOKEN = getCookie('ACCESS_TOKEN') || '';
  return ACCESS_TOKEN!='';
}

export function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}

export function setlocalpatient(patient) {
  let accountid = getaccountid()
  localStorage['patient' + accountid] = JSON.stringify(patient);
}

export function getlocalpatient() {
  let accountid = getaccountid()
  return JSON.parse(localStorage['patient' + accountid] || '{}');
}

export function getlocalcardno() {
  return JSON.parse(localStorage.cardno || '{}');
}

export function setlocalcardno(cardno) {
  localStorage.cardno = JSON.stringify(cardno);
}

export function getlocalorderList() {
  return JSON.parse(localStorage.orderList || '{}');
}

export function setlocalorderList(orderList) {
  localStorage.orderList = JSON.stringify(orderList);
}

export function getlocalrecrodItems() {
  return JSON.parse(localStorage.recrodItems || '{}');
}

export function setlocalrecrodItems(recrodItems) {
  localStorage.recrodItems = JSON.stringify(recrodItems);
}

export function getCookie(name) {
  // console.log(document.cookie)
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

export function getparam() {
  var param = {};
  var p = location.href.split('#')[0];
  p = p.split('?');
  if (p.length > 1) {
    p = p[1].split('&');
    p.map((n) => {
      const p2 = n.split('=');
      param[p2[0]] = decodeURI(p2[1]) || '';
    })
  }
  return param;
}

// 换算距离
export function translateDistance (number, util = '米') {
  // debugger
  let res = ''
  if (number < 1000) {
    res += number + util
  } else {
    res += number / 1000 + util
  }
  return res
}


export function diffDate(d1, d2) {
  if (d1>d2){
    let d3 = d2;
    d2 = d1
    d1 = d3
  }
  let begin = new Date(d1.replace(/[\-,\.]/g, "/"));
  let end = new Date(d2.replace(/[\-,\.]/g, "/"));
  let fmt
  let longTime = end - begin;
  if(longTime === 0){
    return fmt = '0秒'
  }
  let o = {
    "d": Math.floor(longTime / 1000 / 60 / 60 / 24),
    "h": Math.floor(longTime / 1000 / 60 / 60 % 24),
    "m": Math.floor((longTime / 1000 / 60) % 60),
    "s": Math.floor((longTime / 1000) % 60)
  }
  if(o['d']){
    fmt = 'd天h小时m分s秒'
  }else if(o['h']) {
    fmt = 'h小时m分s秒'
  }else if (o['m']){
    fmt = 'm分s秒'
  }else if (o['s']){
    fmt = 's秒'
  }
  for (var k in o){
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, o[k])
  }
  return fmt;

}

/**
 * 获取Auth信息
 *     @ApiModelProperty(value = "手机客户端的唯一标识")
 private String imei;

 @ApiModelProperty(value = "操作系统名称")
 private String os;

 @ApiModelProperty(value = "操作系统版本")
 private String osversion;

 @ApiModelProperty(value = "APP版本")
 private String appversion;

 @ApiModelProperty(value = "用户市场来源")
 private String channel;
 */
export function getAuth() {
  let b = getBrowser();
  let auth = {
    imei: '',
    os: b.device || '',
    osversion: '',
    appversion: b.version || '',
    channel: 'H5'
  }
  return auth;
}

export function getAccessToken() {
  //备用
}

export function loadJS(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    var loaded;
    script.src = src;
    script.onload = script.onreadystatechange = function () {
      if (!loaded && (!script.readyState || /loaded|complete/.test(script.readyState))) {
        script.onload = script.onreadystatechange = null;
        loaded = true;
        resolve();
      }
    }
    script.onerror = error => reject(error);
    document.head.appendChild(script);
  });

}

export function promisify(fn) {
  return function (...args) {
    return new Promise((resolve, reject) => {
      fn.apply(this, args.concat(function (err, result) {
        err ? reject(err) : resolve(result);
      }))
    });
  }
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) { //author: meizz
  var week = ['日', '一', '二', '三', '四', '五', '六']
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds(), //毫秒
    'w': week[this.getDay()]
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

String.prototype.Format = function (fmt) {
  return new Date(this.replace(/[\-,\.]/g, "/")).Format(fmt);
}


/**
 * 年龄计算
 * @param fmt age 年份
 * @returns {*}
 * @constructor
 */
String.prototype.ToAge  = function (fmt) {
  if(!fmt) fmt = 'age'
  let nyear = new Date().getFullYear();
  let byear = new Date(this.replace(/[\-,\.]/g, "/")).getFullYear();
  let a = nyear - byear
  fmt = fmt.replace(/(age)/g, a)
  return fmt;
}


// 埋点
export function sendPV(pt, query = {}) {
  // console.log('埋点------')
  if (!pt) {
    pt = window.location.href;
  }

  query = stringifyQuery(query, '@', '@');

  if (window.OASIS_TRACK && window.OASIS_TRACK.trackPageView) {
    window.OASIS_TRACK.trackPageView.push(pt + query);
  }
}

export function sendEV(log, query = {}) {
  query = stringifyQuery(query, '@', '@');

  log = log + query;

  if (window.OASIS_TRACK && window.OASIS_TRACK.trackEvent) {
    window.OASIS_TRACK.trackEvent.push(log);
  }
}

export function stringifyQuery(obj, separator, prefix) {
  separator = separator || '&';
  var ret = Object.keys(obj).sort().reduce(function (ret, key) {
    var val = obj[key];

    if (Array.isArray(val)) {
      val = val.join(',');
    } else if (val === undefined || val === null) {
      return ret;
    }

    if (ret) {
      ret += separator;
    }
    ret += key + '=' + encodeURIComponent(val);

    return ret;
  }, '');

  if (ret && prefix) {
    return prefix + ret;
  } else {
    return ret;
  }
}
// 过滤年龄单位
export function agefilter(ageUnit) {
  let result;
  switch(ageUnit){
    case '年':
      result = '岁';
      break;
    case '月':
      result = '个月';
    break;
    case '日':
      result = '天';
    break;
    default:
      result = '岁';
      break;
  }
  return result;
}
/**
*获取今天以后几个月以后的准确时间
**/
// let now = new Date('2019-08-31')
// let that = this;
// let today = now.getFullYear()+"-"+now.getMonth()+"-"+now.getDate();
export function getNextMonth(date,monthNum) {
    var dateArr = date.split('-');
    var year = dateArr[0]; //获取当前日期的年份
    var month = dateArr[1]; //获取当前日期的月份
    var day = dateArr[2]; //获取当前日期的日
    return new Date(year,(month*1 + monthNum*1),day).Format("yyyy-MM-dd");// 必须这种方法处理new Date()
}
/***
* SKU 数据获取
**/
export function getSKUString(code) {
  let text = '暂无数据';
  const branch = '/\n'
  switch(code){
    case 'vip-30':
        text = `1.每张特惠月卡30天有效期，从购买日开始计时。<br>
        2.有效期内可无限次视频问诊，终身免费查阅问诊报告。<br>
        3.可在泓华医疗APP：我的-我的钱包-套餐卡中查看使用剩余时长。<br>
        4.本卡购买后不支持退款。`;
        break;
    case 'dcty-vip':
        text = `1.支付成功即生效，购买日起30日内任意时间使用有效。<br>
        2.以1个完整的疾病咨询为标准，用户若因网络问题异常中断，可在首次中断后60分钟内，多次重新发起视频问诊。<br>
        3.有效期内未使用可申请退款，过期不退。<br>
        4.终身免费查阅问诊报告。`;
        break;
    case 'vip-3':
        text = `1.每张特惠季卡90天有效期，从购买日开始计时。<br>
        2.有效期内可无限次视频问诊，终身免费查阅问诊报告。<br>
        3.可在泓华医疗APP：我的-我的钱包-套餐卡中查看使用剩余时长。<br>
        4.本卡购买后不支持退款。`
        break;
    case 'vip-6':
        text = `1.  每张特惠半年卡183天有效期，从购买日开始计时。<br>
        2.  有效期内可无限次视频问诊，终身免费查阅问诊报告。<br>
        3.  可在泓华医疗APP：我的-我的钱包-套餐卡中查看使用剩余时长。<br>
        4.  本卡购买后不支持退款。`
        break;
    case 'vip-12':
        text = `1.每张特惠年卡365天有效期，从购买日开始计时。<br>
        2.有效期内可无限次视频问诊，终身免费查阅问诊报告。<br>
        3.可在泓华医疗APP：我的-我的钱包-套餐卡中查看使用剩余时长。<br>
        4.本卡购买后不支持退款。`
        break;
    default:
        text = '暂无数据'
        break;
    }
    return text;
}



// WEBPACK FOOTER //
// ./src/lib/util.js